import ButtonIcon from "#common/buttons/ButtonIcon"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { Box, Paper } from "@mui/material"
import { TextBodyMain, TextTitleMain } from "../text/TextMain"
export function MainDetailsCommonContainer({ children, noUsePaper = false }) {
	return (
		<Box component={noUsePaper ? "div" : Paper} elevation={1} sx={{ p: 1 }}>
			{children}
		</Box>
	)
}

export const MainDetailsCommonContainerItems = ({
	label,
	value,
	icon,
	hidden,
	button,
}) => {
	if (!value || hidden) return null

	const Icon = icon
	const IconB = button?.icon || OpenInNewIcon

	return (
		<Box>
			<Box
				display="inline-flex"
				alignItems="center"
				gap={0.5}
				component="span"
				lineHeight={1}
			>
				<TextTitleMain label={label} />

				{button && (
					<ButtonIcon
						{...button}
						size="small"
						sx={{ p: 0, minWidth: 0, height: "auto", alignSelf: "center" }}
						icon={<IconB color="primary" fontSize="small" />}
					/>
				)}
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				{icon && <Icon fontSize="small" color="action" />}
				<TextBodyMain label={value} />
			</Box>
		</Box>
	)
}

// /**
//  *
//  * @param {import("#common/buttons/ButtonIcon").ButtonIconProps} param0
//  * @returns
//  */
// export const TitleButton = ({ label, ...props }) => {
// 	const Icon = props.icon || OpenInNewIcon
// 	return (
// 		<Box
// 			display="inline-flex"
// 			alignItems="center"
// 			gap={0.5}
// 			component="span"
// 			lineHeight={1}
// 		>
// 			<TextTitleMain label={label} />
// 			<ButtonIcon
// 				{...props}
// 				size="small"
// 				sx={{ p: 0, minWidth: 0, height: "auto", alignSelf: "center" }}
// 				icon={<Icon color="primary" fontSize="small" />}
// 			/>
// 		</Box>
// 	)
// }
